import React, { useState, useEffect } from 'react'
import { Empty, message, Popconfirm, Table, Tooltip } from 'antd'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'

import ModelRankingForm from './ModelRankingForm'
import { deleteModelRanking, getModelRankings } from '../services'
import { handleError } from '../../../helpers'

export default function ModelRankingsModal({ visible, onClose, type, id }) {
	const [modelRankings, setModelRankings] = useState(null)

	useEffect(() => {
		!modelRankings && visible && getModelRankings({
			'filter[model_type]': type,
			'filter[model_id]': id
		})
			.then(res => setModelRankings(res.data.data))
			.catch(error => handleError(error))
	}, [ modelRankings, type, id, visible ])

	const handleDelete = id => {
		deleteModelRanking(id)
			.then(() => {
				message.success('Cargo desasociado exitosamente')
				setModelRankings(null)
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Nombre de Cargo',
			dataIndex: 'ranking_name'
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Popconfirm
						title="¿Segura desea desasociar el cargo?"
						okText="Desasociar"
						cancelText="Cancelar"
						onConfirm={() => handleDelete(record.id)}
						okButtonProps={{ danger: true }}
					>
						<Tooltip title="Desasociar">
							<FontAwesomeIcon 
								className="text-link"
								icon={faUnlink}
							/>
						</Tooltip>
					</Popconfirm>
				</React.Fragment>
			)
		}
	]

	const handleClose = () => {
		onClose()
		setModelRankings(null)
	}

	return (
		<Modal isOpen={visible} toggle={handleClose}>
			<ModalHeader toggle={handleClose}>Cargos Asociados</ModalHeader>
			<ModalBody>
				<Table 
					dataSource={modelRankings}
					rowKey={record => record.id}
					columns={columns}
					size="small"
					locale={{ emptyText: <Empty description='No tiene cargos asociados' imageStyle={{ height: 60 }} /> }}
					loading={!modelRankings}
				/>
				<ModelRankingForm 
					id={id}
					type={type}
					reload={() => setModelRankings(null)}
				/>
			</ModalBody>
		</Modal>
	)
}